import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_4 = { class: "col-lg-4 col-xxl-3" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-4" }
const _hoisted_13 = { class: "col-lg-8" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-8" }
const _hoisted_16 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentChart = _resolveComponent("PaymentChart")!
  const _component_ActiveUserChart = _resolveComponent("ActiveUserChart")!
  const _component_RevenueChart = _resolveComponent("RevenueChart")!
  const _component_ConversionChart = _resolveComponent("ConversionChart")!
  const _component_TopRefers = _resolveComponent("TopRefers")!
  const _component_ActiveUsersChart = _resolveComponent("ActiveUsersChart")!
  const _component_LatestTransaction = _resolveComponent("LatestTransaction")!
  const _component_UpgradePlans = _resolveComponent("UpgradePlans")!
  const _component_ActiveUsers = _resolveComponent("ActiveUsers")!
  const _component_ProductTradeConditionChart = _resolveComponent("ProductTradeConditionChart")!
  const _component_GrossRevenueChart = _resolveComponent("GrossRevenueChart")!
  const _component_SalesByCountry = _resolveComponent("SalesByCountry")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PaymentChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ActiveUserChart),
        _createVNode(_component_RevenueChart),
        _createVNode(_component_ConversionChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TopRefers)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ActiveUsersChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_LatestTransaction)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_UpgradePlans)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_ActiveUsers)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_ProductTradeConditionChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_GrossRevenueChart)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_SalesByCountry)
      ])
    ])
  ]))
}